

<div class="container">
   <div>You have requested a password reset</div>
    <h4>Please Reset your Password </h4>

    <form [formGroup]='updateForm'>
      <mat-form-field style="margin-top: 20px;" appearance="outline">
        <mat-label>New password</mat-label>
        <input formControlName='password' matInput [type]="hide ? 'password' : 'text'">
  
      </mat-form-field>
    
      <mat-form-field appearance="outline">
          <mat-label>Confirm Password</mat-label>
          <input formControlName='confirmPassword' matInput [type]="hide ? 'password' : 'text'">
  
        </mat-form-field>
    </form>


      <button mat-button (click)="submit()">Submit</button>
  </div>